// src/redux/slices/clientSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ApiGetClientDbName } from '../apiService/Core/Apicall.tsx';

// Define the Client type (adjust based on your API response)
export interface Client {
  clientGroupDBName: string;
  clientGroupName: string;
  // add other properties if available
}

// State type
interface ClientState {
  clientList: Client[];
  clientList2: Client[];
  loading: boolean;
  error: string | null;
  selectedClientGroup:any
}

// Initial state
const initialState: ClientState = {
  clientList: [],
  clientList2: [],
  loading: false,
  error: null,
  selectedClientGroup:null
};

const isTransport = localStorage.getItem('isTransport')

// Async thunk
export const fetchClientList = createAsyncThunk<Client[]>(
  'client/fetchClientList',
  async () => {
    const response = await ApiGetClientDbName();
    const filteredData = response.data.filter((item: any) => item.clientGroupName !== "TRANSPORT");
    return isTransport ? response.data : filteredData 
    // return  filteredData 
  }
);

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setSelectedClientGroupName: (state, action) => {
      state.selectedClientGroup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientList.fulfilled, (state, action: PayloadAction<Client[]>) => {
        state.clientList = action.payload;
        state.clientList2 = [{clientGroupName:"All",clientGroupDBName:"All"},...action.payload];
        state.loading = false;
        state.selectedClientGroup="All"
      })
      .addCase(fetchClientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Something went wrong';
      });
  },
});
export const {setSelectedClientGroupName} = clientSlice.actions
export const clientReducer = clientSlice.reducer;
